<template>
  <div class="animated revealUp">
    <div class="d-flex justify-content-between">

    <div class="d-flex align-items-center" style="gap:10px">
      <div class="d-block">
        <div class="section-title">{{ $t("promotionsandoffer") }}</div>
        <div class="section-subTitle my-2">
          {{ $t("promotionsandoffer_dashmsg") }}
        </div>
        </div>

         <div>
        <b-form-input
          v-debounce:300="getPromotionsAndOffersList"
          v-model="searchValue"
          placeholder="Search..."
        ></b-form-input>
      </div>

      </div>
      

      <div class="d-flex align-items-center" style="gap:10px">
      <div>
        <!-- <b-button variant="default" to="profile" class="btn-blue">{{ $t('Profile') }}</b-button> -->
        <b-button
          v-if="cinema_manager_add_edit_disabled != 3"
          variant="default"
          to="add-promotions-and-offers"
          class="btn-blue"
          >{{ $t("add") }}</b-button
        >
        <!-- <b-dropdown
          :text="selectedStatus"
          variant="dropdown-curve"
          class="ml-auto mr-3"
        >
          <b-dropdown-item
            v-for="(status, statusIndex) in statuses"
            :key="statusIndex"
            v-on:click="filterStatus(status.status)"
            >{{ status.status }}</b-dropdown-item
          >
        </b-dropdown> -->
      </div>

<div class="">
        <FilterByStatusDropdown
          :onSelect="
            filterIsActive => {
              getPromotionsAndOffersList(filterIsActive);
            }
          "
        />
        </div>

        <div class="mx-2">
          <b-dropdown id="listview" variant="outline-blue">
            <template v-slot:button-content>
              {{ $t("viewing") }}&nbsp;
              <strong>{{ selectedvalue }}</strong>
              &nbsp;Of&nbsp;
              <strong>{{ rows }}</strong>
            </template>
            <b-dropdown-item
              v-for="(list, listIndex) in viewingnumbers"
              :key="listIndex"
              @click="onDropDownChangeValue(list.name)"
              >{{ list.name }}</b-dropdown-item
            >
          </b-dropdown>
        </div>


</div>
</div>

    <div class="d-flex justify-content-between align-items-center my-3" v-if="gridView && listView == true">
     
      <div class="d-flex"></div>
      
        <button
          class="btnj btn-gridView mr-3"
          v-if="GridViewFlag"
          :class="gridView ? 'active' : ''"
          v-on:click="viewType('gridView')"
        ></button>
        <button
          class="btnj btn-listView"
          v-if="GridViewFlag"
          :class="listView ? 'active' : ''"
          v-on:click="viewType('listView')"
        ></button>
      </div>
    

    <!-- GRID VIEW -->

    <div class="desg-grid-container" v-if="gridView">
      <div
        class="col-md-4 col-lg-4 col-xl-3 px-0"
        v-for="(PromotionOfferItem,
        PromotionOfferItemIndex) in promotionsAndOffersList"
        :key="PromotionOfferItemIndex"
      >
        <div class="desg-box">
          <div class="d-flex justify-content-between">
            <h6>Active Promotions</h6>
            <div>
              <b-dropdown right variant="edit">
                <b-dropdown-item
                  v-if="cinema_manager_add_edit_disabled != 3"
                  @click.prevent.stop="onEditPromotionOffer(PromotionOfferItem)"
                >
                  <span class="edit-pen mr-1"></span>
                  {{ $t("edit") }}
                </b-dropdown-item>
                <b-dropdown-item
                  @click.prevent.stop="onViewPromotionOffer(PromotionOfferItem)"
                >
                  <span class="icon-eye mr-1"></span>
                  {{ $t("view") }}
                </b-dropdown-item>
                <b-dropdown-item to="view-usage-promotions-and-offers">
                  <span class="icon-eye mr-1"></span>
                  {{ $t("view") }} Usage
                </b-dropdown-item>
              </b-dropdown>
            </div>
          </div>

          <div class="d-flex justify-content-between align-items-end">
            <div class="d-flex align-items-end lh-1">
              <div class="count">{{ PromotionOfferItem.offer_title }}</div>
            </div>
            <div class="d-flex align-items-end">
              <!-- <label class="ios-switch">
                <input
                  :checked="PromotionOfferItem.os_is_active == 'Y'"
                  type="checkbox"
                  class="ios-checkbox"
                />
                <span class="switch-slider"></span>
              </label> -->
              <StatusDot
                :status="
                  PromotionOfferItem.os_is_active == 'Y'
                    ? 'active'
                    : PromotionOfferItem.os_is_active == 'N' && 'inactive'
                "
              />
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- LIST VIEW DESIGNATION -->
    <div class="desg-list-container" v-if="listView" style="margin-bottom:15px;">

      <div class="desg-list-header justify-content-start">
        
        <div class="pr-3">{{ $tc("status", 2) }}</div>

        <div>
          <img
            v-if="this.columnName != 'offer_title'"
            @click="onSortValue('offer_title', 'asc')"
            src="@/assets/img/icons/updown.svg"
            class="cursor-pointer"
            width="15px"
            height="20px"
          />
          <img
            v-else-if="isSort && isAscending"
            @click="onSortValue('offer_title', 'asc')"
            src="@/assets/img/icons/asc.svg"
            class="cursor-pointer"
            width="15px"
            height="20px"
          />
          <img
            v-else
            @click="onSortValue('offer_title', 'desc')"
            src="@/assets/img/icons/desc.svg"
            class="cursor-pointer"
            width="15px"
            height="20px"
          />
          {{ $t("promotionsandoffer") }}
        </div>
        
      </div>
      <ul v-if="promotionsAndOffersList.length > 0" class="desg-list back_list">
        <li
          class="main_li justify-content-start"
          v-for="(PromotionOfferItem,
          PromotionOfferItemIndex) in promotionsAndOffersList"
          :key="PromotionOfferItemIndex"
        >
             <div class="d-flex align-items-center">
            <!-- <label class="ios-switch">
              <input
                :checked="PromotionOfferItem.os_is_active == 'Y'"
                disabled
                type="checkbox"
                class="ios-checkbox"
              />
              <span class="switch-slider"></span>
            </label> -->
            <StatusDot
              :status="
                PromotionOfferItem.os_is_active == 'Y'
                  ? 'active'
                  : PromotionOfferItem.os_is_active == 'N' && 'inactive'
              "
            />
            <b-dropdown right variant="edit" class="ml-2">
              <b-dropdown-item
                v-if="cinema_manager_add_edit_disabled != 3"
                @click.prevent.stop="onEditPromotionOffer(PromotionOfferItem)"
              >
                <span class="edit-pen mr-1"></span>
                {{ $t("edit") }}
              </b-dropdown-item>
              <b-dropdown-item
                @click.prevent.stop="onViewPromotionOffer(PromotionOfferItem)"
              >
                <span class="icon-eye mr-1"></span>
                {{ $t("view") }}
              </b-dropdown-item>
              <b-dropdown-item
                @click.prevent.stop="
                  onViewPromotionOfferUsage(PromotionOfferItem)
                "
              >
                <span class="icon-eye mr-1"></span>
                {{ $t("view") }} {{ $t("usage") }}
              </b-dropdown-item>
            </b-dropdown>
          </div>

          <div class="pl-4">{{ PromotionOfferItem.offer_title }}</div>
     
        </li>
      </ul>
      <table class="w-100" v-if="promotionsAndOffersList.length === 0">
        <tbody>
          <tr>
            <td colspan="2">
              <!-- <div class="h6 my-3 text-center">{{ $t("NoRecords") }}</div> -->
              <NoRecords/>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
    <br />
    <b-pagination
      v-model="currentPage"
      :total-rows="rows"
      @change="onChangePagination($event)"
      :per-page="perPage"
      aria-controls="my-table"
    ></b-pagination>
  </div>
</template>

<script>
import MarketingService from "@/services/MarketingService";
import StatusDot from "@/components/Partials/StatusDot.vue";
import FilterByStatusDropdown from "@/components/Partials/FilterByStatusDropdown.vue";
import NoRecords from "@/components/Partials/NoRecords.vue";

export default {
  components: {
    StatusDot,
    FilterByStatusDropdown,
    NoRecords
  },
  data() {
    return {
      perPage: 10,
      currentPage: 1,
      rows: 0,
      selectedvalue: "10",

      gridView: false,
      listView: true,
      promotionsAndOffersList: [],

      debounce: null,
      searchValue: "",

      //Sorting data
      isSort: false,
      isAscending: true,
      orderby: "",
      columnName: ""
      // statuses: [
      //   { status: "Active" },
      //   { status: "Inactive" },
      //   { status: "All" }
      // ],
      // selectedStatus: "Active"
    };
  },
  mounted() {
    this.getPromotionsAndOffersList();
  },
  beforeMount() {
    this.cinema_manager_add_edit_disabled = this.secureStore.get(
      "USINFO"
    ).role_id;

    this.getviewingnumber();
  },
  methods: {
    // filterStatus: function(status) {
    //   this.selectedStatus = status;
    //   this.currentPage = 1;
    //   this.getPromotionsAndOffersList();
    // },
    getviewingnumber() {
      this.viewingnumbers = [
        { name: "All", id: 1 },
        { name: "10", id: 2 },
        { name: "20", id: 3 },
        { name: "30", id: 3 },
        { name: "40", id: 4 },
        { name: "50", id: 5 }
      ];
    },
    onDropDownChangeValue(event) {
      if (event == "All") {
        this.perPage = this.rows;
        this.selectedvalue = event;
        this.onChangePagination();
      } else {
        console.log("Numbers :", event);
        this.selectedvalue = event;
        this.perPage = event;
        console.log("perPage :", this.perPage);
        this.onChangePagination();
      }
    },
    /* eslint-disable */
    onChangePagination: function(event) {
      // console.log(event);
      if (event === undefined) {
        this.currentPage = 1;
        this.getPromotionsAndOffersList();
      } else {
        this.currentPage = event;
        this.getPromotionsAndOffersList();
      }
    },
    //Sort
    onSortValue(columnName, orderby) {
      this.isSort = true;
      this.isAscending = !this.isAscending;
      this.columnName = columnName;
      this.orderby = orderby;
      this.getPromotionsAndOffersList();
    },
    getPromotionsAndOffersList: function(filterIsActive = "Y") {
      this.promotionsAndOffersList = [];
      let payload = {
        limit: this.perPage,
        currentPage: this.currentPage,
        columnName: this.columnName,
        orderBy: this.orderby,
        searchValue: this.searchValue,
        status: filterIsActive
      };
      MarketingService.GetPrmotionAndoffers(payload)
        .then(response => {
          const { data } = response;
          if (data && data.status) {
            if (data.Records.length > 0) {
              this.promotionsAndOffersList = data.Records;
              this.rows = data.totalRows;
            }
          } else {
            this.$toasted.show(data.message);
          }
        })
        .catch(this._CatchError);
    },
    /* eslint-disable */
    onEditPromotionOffer: function({ os_id }) {
      this.$router.push({
        path: "/marketing/edit-promotions-and-offers",
        query: { os_id }
      });
    },
    onViewPromotionOffer: function({ os_id }) {
      this.$router.push({
        path: "/marketing/view-promotions-and-offers",
        query: { os_id }
      });
    },
    onViewPromotionOfferUsage: function({ os_id }) {
      this.$router.push({
        path: "/marketing/view-usage-promotions-and-offers",
        query: { os_id }
      });
    },

    viewType: function(viewType) {
      if (viewType == "gridView") {
        this.gridView = true;
        this.listView = false;
      } else if ((viewType = "listView")) {
        this.listView = true;
        this.gridView = false;
      }
    }
    // onClickEdit: function(){
    //   this.$router.push({ path: 'master/editaggregators' })
    // }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/Pages/MarketingContainer/PromotionsAndOffersComponent/promotionsAndOffers.vue